import { CUSTOMER_STATUSES, CustomerStatus } from '@vy/types';

export const STATUS_COLORS_CONFIG: Record<CustomerStatus, { backgroundColor: string; color: string }> = {
  [CUSTOMER_STATUSES.Active]: { backgroundColor: '#DFFAE5', color: '#2C9746' },
  [CUSTOMER_STATUSES.Inactive]: { backgroundColor: '#E8EBF2', color: '#5F6978' },
  [CUSTOMER_STATUSES.Suspended]: { backgroundColor: '#FEEBEE', color: '#EE2049' },
  [CUSTOMER_STATUSES.Trial]: { backgroundColor: '#F4F2FF', color: '#7E4CFF' },
};
